import SendBird from "sendbird";

let instance = null;

class Sendbird {
  constructor() {
    if (instance) {
      return instance;
    }
    this.sb = new SendBird({
      appId: process.env.REACT_APP_SB_APP_ID
    });
    instance = this;
  }

  connect(userId, access_token) {
    return new Promise((resolve, reject) => {
      this.sb.connect(userId, access_token, (user, error) => {
        error ? reject(error) : resolve(user);
      });
    });
  }
  listMyGroupChannelList = async () => {
    return new Promise((resolve, reject) => {
      var channelListQuery = this.sb.GroupChannel.createMyGroupChannelListQuery();
      channelListQuery.includeEmpty = true;
      channelListQuery.limit = 100;
      resolve(channelListQuery);
    });
  };
  loadPreviouseMessages = async channel => {
    return new Promise((resolve, reject) => {
      var prevMessageListQuery = channel.createPreviousMessageListQuery();
      prevMessageListQuery.limit = 30;
      prevMessageListQuery.reverse = true;
      resolve(prevMessageListQuery);
    });
  };
  sendMessage = async (channel, message, media) => {
    return new Promise((resolve, reject) => {
      const params = new this.sb.UserMessageParams();
      params.message = message;
      params.data = JSON.stringify(media);
      channel.sendUserMessage(params, (message, error) => {
        if (error) reject(error);
        resolve(message);
      });
    });
  };
}

export { Sendbird };

export const isCurrentUser = user => {
  return user.userId === instance.sb.currentUser.userId;
};
